import React from "react";
import { Helmet } from "react-helmet-async";
import logo from "../Images/Body-Soul-LLC.png";

const About = () => {
  return (
    <div className="p-[6%] sm:px-[10%] sm:py-[2%]">
      <Helmet>
        <title>{`Who We Are - Earth Beauty and You`}</title>
        <meta
          name="description"
          content="Discover the heart and philosophy of Earth Beauty & You — where nature, integrity, and authentic beauty come together in harmony."
        />
        <link rel="canonical" href={`https://earthbeautyandyou.com/about`} />
      </Helmet>

      <h1 className="text-4xl font-bold my-10 text-center">
        <span className="text-accent font-bold">Earth</span> Beauty &{" "}
        <span className="text-accent font-bold">You</span>
      </h1>

      <div className="flex flex-col lg:flex-row gap-10 items-center justify-center">
        <div className="w-[100%] lg:w-[50%]">
          <p className="font-bold text-[18px] mb-6 leading-relaxed">
            In a world where beauty is often defined by fleeting trends,{" "}
            <span className="text-accent font-semibold">
              Earth Beauty & You
            </span>{" "}
            stands firm in a different promise — beauty that honors the Earth,
            nurtures your body, and reveals your natural radiance.
          </p>

          <p className="font-bold text-[18px] mb-6 leading-relaxed">
            At Earth Beauty & You, we believe true beauty isn’t about covering
            up — it’s about bringing forth what’s already there. It’s the glow
            of healthy skin, the confidence in authenticity, the harmony between
            nature and self. Everything we create is a bridge between earth’s
            wisdom and your unique light.
          </p>

          <p className="text-accent font-bold text-[20px] mt-8 mb-4">
            Why we do what we do:
          </p>

          <ul className="font-bold text-[18px] mb-6 list-disc ml-6 space-y-2">
            <li>
              Because the earth gives us more than ingredients — it gives us
              stories, cycles, resilience, and care.
            </li>
            <li>
              Because your skin deserves nourishment that’s as kind and
              intentional as your heart.
            </li>
            <li>
              Because beauty should not cost the planet, but uplift it in
              return.
            </li>
          </ul>

          <p className="font-bold text-[18px] mt-8 mb-6 leading-relaxed">
            When you choose{" "}
            <span className="text-accent font-semibold">
              Earth Beauty & You
            </span>
            , you’re not only choosing a product — you’re choosing a promise:
          </p>

          <blockquote className="border-l-4 border-accent pl-4 italic text-[18px] font-semibold space-y-2">
            <p>• A promise to treat your body with respect,</p>
            <p>• A promise to give back to the earth with gratitude,</p>
            <p>• A promise to walk in alignment with your truest self.</p>
          </blockquote>

          <p className="mt-10 font-bold text-[16px] leading-relaxed">
            Under License
            <br />
            Body & Soul LLC
            <br />
            16192 Coastal Highway Lewes, Delaware 19958
          </p>

          <br />
          <img className="w-[180px]" alt="Body & Soul LLC Logo" src={logo} />
        </div>
      </div>
    </div>
  );
};

export default About;
